import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
};

export const useCancelDraftPermit = ({
  orderId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate, isPending, isError } = useMutation({
    mutationFn: (data: { permitApplicationId: string }) =>
      OrdersClient.cancelDraftPermit({
        orderId,
        permitApplicationId: data.permitApplicationId,
      }),
    onSuccess,
    onError,
  });

  return {
    cancelDraftPermit: mutate,
    isPending,
    isError,
  };
};
